import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import isEqual from 'react-fast-compare'
import { Motion, spring } from 'react-motion'

import stackedSliderStyles from './StackedSlider.css'
import { MOTION_PRESETS } from '/react/constants/motionPresets'

export class StackedSliderSlide extends Component {
  static propTypes = {
    goToNextSlide: PropTypes.func.isRequired,
    hasStackedLayout: PropTypes.bool.isRequired,
    motionStyles: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onTouchEnd: PropTypes.func,
    onTouchMove: PropTypes.func,
    onTouchStart: PropTypes.func,
    positionInStack: PropTypes.number.isRequired,
    slide: PropTypes.element.isRequired
  }

  springConfig = MOTION_PRESETS.FAST

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps)
  }

  render () {
    const {
      activeSlideRef,
      hasStackedLayout,
      motionStyles,
      onClick,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      positionInStack,
      slide
    } = this.props

    const shouldAnimate = positionInStack >= 2 && positionInStack <= 4

    const slideProps = {
      onClick,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      ref: activeSlideRef
    }

    return (
      <Motion
        defaultStyle={{
          positionDelta: motionStyles.positionDelta,
          opacity: motionStyles.opacity,
          scale: motionStyles.scale,
          zIndex: motionStyles.zIndex
        }}
        style={{
          positionDelta: shouldAnimate ? spring(motionStyles.positionDelta, this.springConfig) : motionStyles.positionDelta,
          opacity: shouldAnimate ? spring(motionStyles.opacity, this.springConfig) : motionStyles.opacity,
          scale: shouldAnimate ? spring(motionStyles.scale, this.springConfig) : motionStyles.scale,
          zIndex: motionStyles.zIndex
        }}
      >
        {(interpolatedStyle) => {
          const transform = hasStackedLayout
            ? `translate3d(${interpolatedStyle.positionDelta}px, ${interpolatedStyle.positionDelta}px, 0) scale(${interpolatedStyle.scale})`
            : `translate3d(${interpolatedStyle.positionDelta}%, 0, 0) scale(${interpolatedStyle.scale})`

          return (
            <div
              className={classNames(
                stackedSliderStyles.slide,
                stackedSliderStyles.slideIsStacked
              )}
              style={{
                opacity: interpolatedStyle.opacity,
                transform,
                zIndex: interpolatedStyle.zIndex
              }}
              {...slideProps}
            >
              {slide}
            </div>
          )
        }}
      </Motion>
    )
  }
}
